const defaultState = {
    cachedMeasures: {},
};

const mutations = {
    setCachedMeasuresForKey(state, { cachedMeasuresWithKey }) {
        const { cacheKey, cacheMeasures } = cachedMeasuresWithKey;
        state.cachedMeasures[cacheKey] = cacheMeasures;
    },
};

const actions = {
    async setMeasuresInCache(context, query) {
        const { data } = await this.$rq.getMeasureHistory(query);

        const measuresPerCacheKey = data.measures.reduce((measuresMap, measure) => {
            const measures = { ...measuresMap };
            const { component, analysisType } = measure.source;
            const cacheKey = `id_${component}${analysisType}`;

            if (!(cacheKey in measures)) {
                measures[cacheKey] = [];
            }

            measures[cacheKey].push(measure);
            return measures;
        }, {});

        Object.keys(measuresPerCacheKey).forEach(cacheKey => {
            context.commit({
                type: 'setCachedMeasuresForKey',
                cachedMeasuresWithKey: {
                    cacheKey,
                    cacheMeasures: measuresPerCacheKey[cacheKey],
                },
            });
        });
    },
    async getMeasures(context, { component, analysisType, limit }) {
        const cacheKey = `id_${component}${analysisType}`;
        await context.dispatch('setMeasuresInCache', {
            source: {
                component,
                analysisType,
            },
            limit,
        });
        return context.state.cachedMeasures[cacheKey] || [];
    },
};

const getters = {
    hasMeasure: state => (component, analysisType) => !!state.cachedMeasures[`id_${component}${analysisType}`],
    measures: state => (component, analysisType) => state.cachedMeasures[`id_${component}${analysisType}`],
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
